import { UserRoleEnum } from "./role";

export enum UserProfileEnum {
  // Usuário do perfil Torre de Controle
  CONTROL_TOWER = "CONTROL_TOWER",

  // Usuário do perfil Backoffice
  BACKOFFICE = "BACKOFFICE",

  // Usuário do perfil Concessionária
  DEALERSHIP = "DEALERSHIP",

  // Usuário do perfil Gestor de Frota
  FLEET_MANAGER = "FLEET_MANAGER",

  // Usuário do perfil Parceria
  PARTNERSHIP = "PARTNERSHIP",
}

export enum ProfileRouteEnum {
  CONTROL_TOWER = "/control-tower",
  BACKOFFICE = "/backoffice",
  DEALERSHIP = "/dealership",
  FLEET_MANAGER = "/fleet-manager",
  PARTNERSHIP = "/partnership",
}

export enum ProfileNameEnum {
  CONTROL_TOWER = "Torre de Controle",
  BACKOFFICE = "Backoffice",
  DEALERSHIP = "Concessionária",
  FLEET_MANAGER = "Gestor de Frota",
  PARTNERSHIP = "Parceria",
}

export const ProfileRoleMap: Record<UserProfileEnum, UserRoleEnum> = {
  [UserProfileEnum.CONTROL_TOWER]: UserRoleEnum.TOWER,
  [UserProfileEnum.BACKOFFICE]: UserRoleEnum.TOWER,
  [UserProfileEnum.DEALERSHIP]: UserRoleEnum.CONSULTANT,
  [UserProfileEnum.FLEET_MANAGER]: UserRoleEnum.MANAGER,
  [UserProfileEnum.PARTNERSHIP]: UserRoleEnum.PARTNERSHIP,
};

export const ProfileRouteMap: Record<UserProfileEnum, ProfileRouteEnum> = {
  [UserProfileEnum.CONTROL_TOWER]: ProfileRouteEnum.CONTROL_TOWER,
  [UserProfileEnum.BACKOFFICE]: ProfileRouteEnum.BACKOFFICE,
  [UserProfileEnum.DEALERSHIP]: ProfileRouteEnum.DEALERSHIP,
  [UserProfileEnum.FLEET_MANAGER]: ProfileRouteEnum.FLEET_MANAGER,
  [UserProfileEnum.PARTNERSHIP]: ProfileRouteEnum.PARTNERSHIP,
};

export const ProfileNameMap: Record<UserProfileEnum, ProfileNameEnum> = {
  [UserProfileEnum.CONTROL_TOWER]: ProfileNameEnum.CONTROL_TOWER,
  [UserProfileEnum.BACKOFFICE]: ProfileNameEnum.BACKOFFICE,
  [UserProfileEnum.DEALERSHIP]: ProfileNameEnum.DEALERSHIP,
  [UserProfileEnum.FLEET_MANAGER]: ProfileNameEnum.FLEET_MANAGER,
  [UserProfileEnum.PARTNERSHIP]: ProfileNameEnum.PARTNERSHIP,
};

export const getBudgetsKanbanRoute = (profile: UserProfileEnum): string => {
  return `${ProfileRouteMap[profile]}/budgets-kanban`;
};

export const getBudgetsRoute = (profile: UserProfileEnum): string => {
  return `${ProfileRouteMap[profile]}/budgets`;
};

export const isShowKanban = (profile: UserProfileEnum): boolean => {
  return profile === UserProfileEnum.CONTROL_TOWER ||
         profile === UserProfileEnum.DEALERSHIP ||
         profile === UserProfileEnum.FLEET_MANAGER;
};
